import React from 'react';
import './login.css';
import icone from '../../assets/mobile/logo.png';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const user = {
      username: this.state.username,
      password: this.state.password,
    };

    fetch('http://192.168.2.188:1880/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.createSession(300 * 60000);
      } else {
        alert("Credenciais inválidas. Tente novamente.");
      }
    })
    .catch((error) => {
      console.error('Erro na conexão:', error);
    });
  }

  createSession = (duration) => {
    const expirationTime = new Date().getTime() + duration;
    sessionStorage.setItem("loggedIn", "true");
    if (this.state.username === "admin") {
      sessionStorage.setItem("admin", "true");
      sessionStorage.setItem("username", "Administrador");
    } else {
      sessionStorage.setItem("username", "Condominio " + this.state.username);
    }
    sessionStorage.setItem("expirationTime", expirationTime);
    this.props.navigate('/home'); // Redireciona para /home
  }

  render() {
    return (
      <div className="content-login">
        <div className="login-container">
          <img src={icone} alt="Logo" id="icone" />
          <h2 className='h2-login'>Login</h2>
          <form onSubmit={this.handleSubmit}>
            <input className='input-login' type="text" id="username" placeholder="Nome de usuário" required onChange={this.handleChange} />
            <input className='input-login' type="password" id="password" placeholder="Senha" required onChange={this.handleChange} />
            <button className='button-login' type="submit">Entrar</button>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;